import { RevisionAssistantControlCode } from '@enums/revision-assistant-control-code.enum';
import { RevisionAssistantControlLevel } from '@enums/revision-assistant-control-level.enum';
import { RevisionAssistantControlType } from '@enums/revision-assistant-control-type.enum';
import { ConsistencyCheck, ConsistencyCheckJson } from '@models/consistency-check';

export interface RevisionAssistantControlJson {
  code: RevisionAssistantControlCode;
  type: RevisionAssistantControlType;
  label: string;
  level: RevisionAssistantControlLevel;
  context: Partial<ConsistencyCheckJson>;
}

export class RevisionAssistantControl {
  constructor(
    public code?: RevisionAssistantControlCode,
    public type?: RevisionAssistantControlType,
    public label?: string,
    public level?: RevisionAssistantControlLevel,
    public context?: ConsistencyCheck
  ) {}

  static fromJson(json: Partial<RevisionAssistantControlJson>): RevisionAssistantControl {
    return new RevisionAssistantControl(
      json.code,
      json.type,
      json.label,
      json.level,
      json.context ? ConsistencyCheck.fromJson(json.context) : null
    );
  }
}
